export default function getResource(label, vars = []) {
    const resources = {
        free: 'GRATUIT',
        billedMonthly: 'facturé par mois'
    };
    return resources[label];
}
